import React from 'react';
import {Prequal} from '../../../Core/mobx/ParameterStore/Prequal';
import {Parameter} from '../../../Core/mobx/ParameterStore/ParameterStore';
import {observer} from 'mobx-react-lite';
import {CategoryCard} from '../CategoryCard';
import ExistingPoliciesQuestions from '../../Questions/ExistingPolicies';
import {Approval} from '../../../Core/mobx/ParameterStore/Approval';

type ExistingPoliciesProps = {
    valueChanged: (p?: Parameter, value?: any) => void;
    setCategory: (entry: string) => void;
    parameters: Prequal | Approval;
    index: number;
};

const ExistingPolicies = observer(({valueChanged, setCategory, parameters, index}: ExistingPoliciesProps) => {
    return (
        <CategoryCard title={'Existing Policies'} setCategory={setCategory} index={index}>
            <ExistingPoliciesQuestions parameters={parameters} valueChanged={valueChanged} preapproval />
        </CategoryCard>
    );
});

export default ExistingPolicies;
